module.exports = __webpack_public_path__ + "img/logo-nft-dark-nav.a2acade8.png";